<template>
    <div v-if="param.isShow">
        <div class="popup-dimmed on" />
        <div class="popup-wrapper big on">
            <div class="popup-container">
                <div class="popup-body">
                    <div
                        v-if="param.data.tunnelConstructionMethod == tunnelConstructionNATM"
                        class="picture-wrapper"
                        style="width:100%"
                    >
                        <div class="image-box" style="width:100%">
                            <img
                                v-if="param.data.threeDimensionalImageUrl"
                                :src="fileUrl + param.data.threeDimensionalImageUrl"
                                style="max-width: 885px;max-height: 625px;margin: auto;"
                                @error="imgError"
                            />
                            <img
                                v-else="param.data.frontImageUrl"
                                :src="fileUrl + param.data.frontImageUrl"
                                style="max-width: 885px;max-height: 625px;margin: auto;"
                                @error="imgError"
                            />
                        </div>
                    </div>
                    <div v-else class="picture-wrapper" style="width: 100%;">
                        <div class="image-box">
                            <img
                                :src="fileUrl + param.data.tbmLeftImageUrl"
                                style="margin: 0 auto;"
                                @error="imgError"
                            />
                        </div>
                        <div class="image-box">
                            <img
                                :src="fileUrl + param.data.tbmRightImageUrl"
                                style="margin: 0 auto;"
                                @error="imgError"
                            />
                        </div>
                    </div>
                </div>

                <div class="popup-bottom">
                    <p>{{ param.data.station }}</p>
                    <div class="btn-wrapper">
                        <button class="btn btn-cancel" @click="close()">
                            <span>취소</span>
                        </button>
                        <button class="btn btn-confirm" @click="detail(param.data)">
                            <span>상세</span>
                        </button>
                    </div>
                </div>
            </div>
            <button class="popup-close" @click="close()">
                <span class="blind">닫기</span>
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { NO_IMG, FILE_URL, TUNNEL_CONSTRUCTION } from '../../const';

export default {
    name: 'SlidePop',
    components: {},
    props: {
        param: {
            type: Object
        }
    },
    data: () => {
        return {
            tunnelConstructionNATM: TUNNEL_CONSTRUCTION.NATM,
            fileUrl: FILE_URL
        };
    },
    watch: {
        param: {
            // the callback will be called immediately after the start of the observation
            immediate: true,
            deep: true,
            handler(val) {
                this.param = val;
            }
        }
    },
    computed: {
        ...mapState({})
    },
    beforeCreate() {},
    created() {},
    mounted() {},
    beforeDestroy() {},
    methods: {
        ...mapActions([]),
        close() {
            this.param.isShow = false;
        },
        detail(data) {
            if (data.tunnelConstructionMethod == this.tunnelConstructionNATM) {
                this.$router.push({ path: `/detail/${data.constructionCode}/${data.id}` });
            } else {
                this.$router.push({ path: `/detailTBM/${data.constructionCode}/${data.id}` });
            }
        },
        imgError(e) {
            e.target.src = NO_IMG;
        }
    }
};
</script>
